export default __webpack_public_path__ + "static/coveInUse-ba015ab2d1f75e16b3c75b5157e70eff.jpg";